import React, { Component } from 'react'
import { Radio } from 'antd'
import styles from './index.module.css'

export default class ShortRadio extends Component {
    constructor(props) {
        super(props)
        this.state = {
            index: this.props.index,
            data: this.props.data,
            desc: this.props.data.desc,
            options: this.props.data.options,
            choosed: '',
            require: this.props.data.require,
            isWrite:this.props.isWrite
        }
    }

    componentDidMount() {
        this.setState({
            choosed: this.props.answer
        }, () => this.dataUpload())

    }

    choosedChange = (e) => {
        this.setState({
            choosed: e.target.value
        }, () => this.dataUpload())
    }

    dataUpload = () => {
        const { index, choosed } = this.state
        const data = {
            key: this.state.data.key,
            type: this.state.data.type,
            answer: choosed
        }
        this.props.getItemAnswer(data, index)
    }

    render() {
        const { desc, options, choosed, require,isWrite } = this.state
        return (
            <div>
                <div className={styles.title}>
                    <span style={{ color: 'red', display: require === '1' ? 'inline-block' : 'none', marginRight: '5px' }}>*</span>
                    <span>{desc}</span>
                </div>
                <div>
                    <Radio.Group disabled={!isWrite} onChange={this.choosedChange} value={choosed} >
                        {options.map(item =>
                            <Radio key={item.id} value={item.id}>{item.desc}</Radio>
                        )}
                    </Radio.Group>
                </div>
            </div>
        )
    }
}